<template>
  <el-dialog title="Edit Track" :visible="showDialog" width="600px" top="3vh" :modal="true"
      :close-on-click-modal="true" :destroy-on-close="true" @close="close" @open="open" class="distro-dialog">

    <el-form ref="track" :model="track" label-position="top">
    <div class="mb20" style="text-align: center">
      <el-switch  v-model="track.delivered" active-text="Delivered" inactive-text="Not Delivered"
                  active-color="#13ce66" inactive-color="#df2758"></el-switch>
    </div>
    <el-collapse accordion>
<!--   Release Information   -->
      <el-collapse-item title="Release Information (Global Scope)" name="1">
        <el-form-item label="Release Title">
          <el-input v-model="track.album.release_title"></el-input>
        </el-form-item>
        <el-form-item label="Release Format">
          <el-select v-model="track.album.release_format" filterable placeholder="Select" style="width: 100%">
            <el-option v-for="item in assets.releaseFormat" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Release Artist">
          <el-select v-model="track.album.artist_id" filterable placeholder="Select" style="width: 100%">
            <el-option v-for="item in assets.artists" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Official Release Date">
          <el-date-picker style="width: 100%" v-model="track.album.release_date" type="date"
              :value-format="'yyyy-MM-dd'" format="d MMMM yyyy">></el-date-picker>
        </el-form-item>
        <el-form-item label="Contributors">
          <div v-if="track.album.contributors && track.album.contributors.length > 0">
            <ul>
              <li v-for="(contributor, index) in track.album.contributors" :key="index">
                {{ contributor.contributor_name	 }}
                <br>
                <el-button class="btn-contributor float-right" size="small" @click="deleteContributor(index)">Delete</el-button>
                <el-tag type="info" v-for="role in contributor.roles" class="ml5"> {{ role.name }}</el-tag>
              </li>
            </ul>
          </div>
          <div v-else>There are no contributors</div>
          <div style="padding-left: 20px">
            <el-form-item label="Contributor Name">
              <el-input v-model="contributor.name"></el-input>
            </el-form-item>
            <el-form-item label="Role Type">
              <el-select v-model="contributor.roles" filterable placeholder="Select" style="width: 100%" multiple>
                <el-option v-for="item in assets.roles" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <p v-if="contributorError">All fields are required</p>
            <el-button class="btn-contributor mt5" size="small" @click="addContributor()">Add</el-button>
          </div>
        </el-form-item>
        <el-form-item label="UPC Code">
          <el-input v-model="track.album.upc_code"></el-input>
        </el-form-item>
        <el-form-item label="Label Name">
          <el-select v-model="track.album.label_id" filterable placeholder="Select" style="width: 100%">
            <el-option v-for="item in assets.labels" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Catalogue Number">
          <el-input v-model="track.album.unique_catalogue_number"></el-input>
        </el-form-item>
        <el-form-item label="Copyright (C-Line)">
          <el-input v-model="track.album.copyright_holder_c_line"></el-input>
        </el-form-item>
        <el-form-item label="Copyright Year (C-Line)">
          <el-select v-model="track.album.copyright_year_c_line" filterable placeholder="Select" style="width: 100%">
            <el-option v-for="item in years" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Copyright (P-line)">
          <el-input v-model="track.album.copyright_holder_p_line"></el-input>
        </el-form-item>
        <el-form-item label="Copyright Year (P-line)">
          <el-select v-model="track.album.copyright_year_p_line" filterable placeholder="Select" style="width: 100%">
            <el-option v-for="item in years" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Country Of Recording">
          <el-select v-model="track.album.country_of_recording_iso" filterable placeholder="Select" style="width: 100%">
            <el-option v-for="item in assets.countries" :key="item.iso" :label="item.name" :value="item.iso">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Year Of Recording">
          <el-select v-model="track.album.year_of_recording" filterable placeholder="Select" style="width: 100%">
            <el-option v-for="item in years" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-collapse-item>
<!--   Track Info   -->
      <el-collapse-item title="Track Info" name="2">
        <el-form-item label="Track Title">
          <el-input v-model="track.title"></el-input>
        </el-form-item>
        <el-form-item label="Mix Version">
          <el-select v-model="track.mix_version" filterable placeholder="Select" style="width: 100%">
            <el-option v-for="item in assets.mix" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="ISRC Code">
          <el-input v-model="track.isrc_code"></el-input>
        </el-form-item>
      </el-collapse-item>
<!--   Artists & Contributors   -->
      <el-collapse-item title="Artists & Contributors" name="3">
        <el-form-item label="Artist">
          <el-select v-model="track.artist_id" filterable placeholder="Select" style="width: 100%">
            <el-option v-for="item in assets.artists" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Contributors">
          <div v-if="track.album.contributors && track.album.contributors.length > 0">
            <el-select v-model="track.contributor_ids" filterable placeholder="Select" style="width: 100%" multiple>
              <el-option v-for="item in track.album.contributors" :key="item.id" :label="item.contributor_name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="Composer">
          <el-input v-model="track.composer"></el-input>
        </el-form-item>
        <el-form-item label="Lyricist" :required="!track.lyricist_instrumental">
          <el-input v-model="track.lyricist"></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="track.lyricist_instrumental">Instrumental (no lyrics)</el-checkbox>
        </el-form-item>
        <el-form-item label="Producer">
          <el-input v-model="track.producer"></el-input>
        </el-form-item>
      </el-collapse-item>
<!--   Genres & Languages   -->
      <el-collapse-item title="Genres & Languages" name="4">
        <el-form-item label="Primary Genre">
          <el-select v-model="track.primary_genre_id" filterable placeholder="Select" style="width: 100%">
            <el-option v-for="item in assets.genres" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Language">
          <el-input disabled v-model="track.language"></el-input>
        </el-form-item>
      </el-collapse-item>
<!--   Distribution Settings   -->
      <el-collapse-item title="Distribution Settings" name="5">
        <el-form-item label="Platforms">
          <el-select v-model="track.album.stores" filterable placeholder="Select" style="width: 100%" multiple>
            <el-option v-for="item in assets.platforms" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-collapse-item>
<!--   Legal   -->
      <el-collapse-item v-if="track.album.legal" title="Legal" name="6">
        <el-form-item label="Owned Territories">
          <el-select v-model="track.album.legal.owned_territories" filterable placeholder="Select" style="width: 100%" multiple collapse-tags>
            <el-option v-for="item in assets.countries" :key="item.iso" :label="item.name" :value="item.iso">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Percentage of Ownership (%)">
          <el-input v-model="track.album.legal.percentage_of_ownership"></el-input>
        </el-form-item>
        <el-form-item label="Match Policy">
          <el-select v-model="track.album.legal.matched_policy" filterable placeholder="Select" style="width: 100%">
            <el-option v-for="item in assets.policy" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-collapse-item>
<!--   Promotion   -->
<!--      <el-collapse-item title="Promotion" name="7">-->
<!--        <el-form-item label="Platforms">-->
<!--          <el-select v-model="track.album.stores" filterable placeholder="Select" style="width: 100%" multiple>-->
<!--            <el-option v-for="item in assets.platforms" :key="item.id" :label="item.name" :value="item.id">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="FFM Link">-->
<!--          <el-input v-model="track.upc_code"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="Blue Box Text">-->
<!--          <el-input v-model="track.upc_code"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="Selected Restrictions">-->
<!--          <el-input v-model="track.upc_code"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="Timing">-->
<!--          <el-input v-model="track.upc_code"></el-input>-->
<!--        </el-form-item>-->
<!--      </el-collapse-item>-->
    </el-collapse>
    </el-form>
    <div slot="footer">
      <el-button type="primary" size="mini" :loading="loading" @click="save"> Save </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      form: {},
      moment,
      contributor: { name: '', roles: []},
      contributorError: false
    }
  },
  computed: {
    ...mapState('distro', ['track', 'assets', 'showDialog', 'loading']),

    years() {
      const startYear = 1970;
      const currentYear = moment().year();

      const years = [];

      for (let year = startYear; year <= currentYear; year++) { years.push(year) }

      return years.reverse()
    }
  },

  methods: {
    ...mapMutations('distro', ['setTrack', 'setShowDialog']),
    ...mapActions('distro', ['update']),

    open() {
      if (!Array.isArray(this.track.contributor_ids)) {
        this.track.contributor_ids = this.track.contributor_ids ? [this.track.contributor_ids] : []
      }

      this.track.album.stores =  this.track.album.stores.map(_ => _.id)

      if (this.track.album.legal) {
        const matchPolicy = this.assets.policy.find(_ => _.id === this.track.album.legal.matched_policy)

        this.track.album.legal = {
          owned_territories: this.track.album.legal.owned_territories,
          matched_policy:  matchPolicy ? matchPolicy.id : null,
          percentage_of_ownership: this.track.album.legal.percentage_of_ownership,
        }
      } else {
        this.track.album.legal = {
          owned_territories: [],
          matched_policy: null,
          percentage_of_ownership: null,
        }
      }
    },

    close() {
      this.setShowDialog(false)
      this.setTrack({ album: { legal: {} } })
    },

    async save() {
      await this.update(this.track)
    },

    deleteContributor(index) {
      this.track.album.contributors.splice(index, 1)
    },

    addContributor() {
      if (!this.contributor.name || this.contributor.roles.length < 1) {

        this.contributorError = true
        setTimeout(() => { this.contributorError = false }, 3000)
        return;
      }
      let roles = []

      this.contributor.roles.forEach(_ => {
        roles.push(this.assets.roles.find(c => c.id === _))
      })
      this.track.album.contributors.push({
        contributor_name: this.contributor.name, roles
      })
      this.contributor = { name: '', roles: [] }
    }
  }
}
</script>

<style scoped lang="scss">
.distro-dialog {
  .btn-contributor {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>